var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.837 32.412",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.1 30.459h-.308A14.12 14.12 0 0 1 1.9 16.352l.048-2.327L0 14.38l.069 4.037 1.731.237a14.938 14.938 0 0 0 .827 2.971l-1.342 1.162L3.3 26.242l1.622-.692a14.471 14.471 0 0 0 2.153 2.136l-.606 1.7L9.9 31.332l1.07-1.431a13.738 13.738 0 0 0 2.9.733l.3 1.778 3.919-.088.266-2.017zm.285-24.52a10.53 10.53 0 0 0-10.252 8.185L1.479 9.47A16.457 16.457 0 0 1 30.71 8.358l.274.485h-7.343l-.094-.087a10.457 10.457 0 0 0-7.162-2.817zm-.325 7.543v5.939h10.412a10.489 10.489 0 0 1-7.758 7.284l4.649 4.649a16.407 16.407 0 0 0 4.079-2.72c.189-.172.378-.353.565-.539a16.3 16.3 0 0 0 4.653-9.23 16.643 16.643 0 0 0 .176-2.414v-2.97z",
    style: {
      isolation: "isolate"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.2c919217.svg";
export { ForwardRef as ReactComponent };